<div class="multi-file-upload">
  @if (fileQueue.length > 0) {
    <div class="files-list">
      @for (file of fileQueue; track file.id) {
        <div class="file-item">
          <mat-icon class="file-icon">description</mat-icon>
          <div class="file-details">
            <div class="file-name">{{ file.fileName }}.{{ file.extension.toLowerCase() }}</div>
            <div class="file-status">
              @if (file.status === 'pending') {
                <span>{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.STATUS_PENDING' | translate }}</span>
              } @else if (file.status === 'uploading') {
                <span>{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.STATUS_UPLOADING' | translate }}</span>
              }
            </div>
          </div>
          @if (file.status === 'pending') {
            <button mat-icon-button (click)="removeFileFromQueue(file.id)">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      }
    </div>
  }

  <div
    class="drop-zone"
    [class.dragging]="isDragging"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="fileInput.click()"
  >
    <mat-icon>cloud_upload</mat-icon>
    <p>{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.DRAG_DROP' | translate }}</p>
    <button mat-stroked-button type="button">
      {{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.BROWSE_FILES' | translate }}
    </button>
    <p class="file-requirements">{{ acceptedFileTypesDisplay }} · {{ maxSize | filesize }} {{ 'COMMON.MAX' | translate }}</p>
    <input #fileInput type="file" [accept]="acceptedFileTypesString" multiple hidden (change)="onFileInputChange($event)" />
  </div>
</div>
